/**
 * The URL to replace the current one with when a document **reload** should forget some query
 * params, or `null` when nothing changes. Pure — the caller reads `location` and the navigation
 * type and writes `history`.
 *
 * Exists for the Dealers listing (118479): search and sort survive a reload, page and page size
 * reset. A reload is the only navigation that drops them, so history-back to the listing (ticket
 * 09) still lands on the page it left.
 */
export function dropParamsOnReload(
  pathWithQuery: string,
  navigationType: string | undefined,
  keys: readonly string[],
): string | null {
  if (navigationType !== 'reload') return null;
  const url = new URL(pathWithQuery, 'http://x');
  if (!keys.some((key) => url.searchParams.has(key))) return null;
  keys.forEach((key) => url.searchParams.delete(key));
  const query = url.searchParams.toString();
  return `${url.pathname}${query ? `?${query}` : ''}${url.hash}`;
}
